<template>
  <div>
    <h1 class="content has-text-centered title is-5 has-text-grey-dark">
      Pedido de Compra
    </h1>
    <div class="info order-info">
      <div class="columns is-mobile">
        <div class="column">Nº do pedido de compra:</div>
        <div class="column has-text-right">{{ docNum }}</div>
      </div>
      <div class="columns is-mobile">
        <div class="column">Data do pedido:</div>
        <div class="column has-text-right">{{ formattedDate(docDate) }}</div>
      </div>
      <div class="columns is-mobile">
        <div class="column">Fornecedor:</div>
        <div class="column has-text-right">{{ cardName }}</div>
      </div>
      <div class="columns is-mobile">
        <div class="column">Condição de pagamento:</div>
        <div class="column has-text-right">{{ pymntGroup }}</div>
      </div>
      <div class="columns is-mobile">
        <div class="column">Moeda</div>
        <div class="column has-text-right">{{ docCur }}</div>
      </div>
      <div class="columns is-mobile">
        <div class="column">Previsão de entrega:</div>
        <div class="column has-text-right">{{ formattedDate(docDueDate) }}</div>
      </div>
    </div>

    <b-tabs multiline type="is-boxed">
      <b-tab-item
        v-for="(item, index) in itens"
        :key="index"
        :label="`Item #${index + 1}`"
      >
        <div class="info">
          <div class="columns is-mobile">
            <div class="column">Produto:</div>
            <div class="column has-text-right">{{ item.dscription }}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Quantidade:</div>
            <div class="column has-text-right">{{ item.quantity }}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Preço unitário:</div>
            <div class="column has-text-right">
              {{
                formattedPrice(item.price, docCur, {
                  maximumFractionDigits: 10,
                })
              }}
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Observações do item:</div>
            <div class="column has-text-right">
              {{ itemObservation(item) }}
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Projeto:</div>
            <div class="column has-text-right">
              {{ item.project || "----" }}
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Data da entrega:</div>
            <div class="column has-text-right">
              {{ formattedDate(item.shipDate) }}
            </div>
          </div>
          <div v-if="item.baseEntry" class="columns is-mobile">
            <div class="column">Solicitação de compra:</div>
            <div class="column has-text-right">
              <button
                v-if="loading"
                class="button is-small is-loading"
                style="border: 0"
              />
              <router-link
                v-else
                :to="{ name: 'detail', params: { id: item.baseEntry } }"
                >{{ item.baseEntry }}</router-link
              >
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item :visible="!!comments" label="Observações do Pedido">
        <div v-html="comments" />
      </b-tab-item>
      <b-tab-item :visible="!!alba_Comments" label="Observações Interna">
        <div v-html="alba_Comments" />
      </b-tab-item>
      <b-tab-item label="Informações Complementares">
        <div class="info">
          <div class="columns is-mobile">
            <div class="column">Saving:</div>
            <div class="column has-text-right">
              {{ formattedPrice(saving, docCur) }}
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Comprador:</div>
            <div class="column has-text-right">{{ buyer }}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Solicitante:</div>
            <div class="column has-text-right">{{ requester }}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column">Departamento:</div>
            <div class="column has-text-right">{{ department }}</div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item
        :visible="despesasAdicionals && despesasAdicionals.length > 0"
        label="Despesas Adicionais"
      >
        <div class="info">
          <div
            class="columns is-mobile"
            v-for="item in despesasAdicionals"
            :key="item.expnsCode"
          >
            <div class="column">{{ item.expnsName }}</div>
            <div class="column has-text-right">
              {{ formattedPrice(item.lineTotal, docCur) }}
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item :visible="anexos && anexos.length > 0" label="Anexos">
        <div class="info">
          <div
            class="columns is-mobile"
            v-for="(item, index) in anexos"
            :key="index"
          >
            <div class="column">
              <i
                v-if="['pdf'].includes(item.fileExt)"
                class="far fa-file-pdf"
              ></i>
              <i
                v-else-if="['xls', 'xlsx'].includes(item.fileExt)"
                class="far fa-file-excel"
              ></i>
              <i
                v-else-if="['doc', 'docx'].includes(item.fileExt)"
                class="far fa-file-word"
              ></i>
              <i
                v-else-if="['jpg', 'jpeg', 'png'].includes(item.fileExt)"
                class="far fa-file-image"
              ></i>
              <i v-else class="far fa-file"></i>

              -
              <a target="_blank" :href="item.link"
                >{{ item.fileName }}.{{ item.fileExt }}</a
              >
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <hr />
    <div class="info summary">
      <div class="columns is-mobile">
        <div class="column">Valor total:</div>
        <div class="column has-text-right">
          {{ formattedPrice(docTotal, docCur) }}
        </div>
      </div>
      <div v-if="docCur !== 'R$'" class="columns is-mobile">
        <div class="column">Taxa de conversão:</div>
        <div class="column has-text-right">
          {{ formattedPrice(docRate, undefined, { minimumFractionDigits: 4 }) }}
        </div>
      </div>
      <div v-if="docCur !== 'R$'" class="columns is-mobile">
        <div class="column">Valor total em Reais:</div>
        <div class="column has-text-right">
          {{ formattedPrice(docTotalReais) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "./detailMixin";

export default {
  name: "pedido",
  mixins: [mixin],
  methods: {
    itemObservation(item) {
      const { freeText, detail } = item;
      if (freeText && detail) return `${item.freeText} - ${item.detail}`;
      if (freeText && !detail) return `${item.freeText}`;
      if (!freeText && detail) return `${item.detail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  .columns {
    margin-top: 0;
    margin-bottom: 0.5rem;
    .column {
      padding: 0 0.75rem;
      margin: 0;
    }
  }
}

.order-info {
  margin-top: 2rem;
  margin-bottom: 2.5rem;
}

.item-info {
  margin-bottom: 1rem;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 4px;
}

.summary {
  margin-top: 1rem;
}
</style>
